var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBellIcon = function SvgBellIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 .9c-1.563 0-3.061.64-4.166 1.78A6.17 6.17 0 0 0 2.11 6.974v3.241l-1.263 3.26a.7.7 0 0 0 .067.627q.091.139.235.218c.094.052.2.079.306.079h3.928c0 1.496 1.167 2.7 2.618 2.7s2.618-1.204 2.618-2.7h3.928a.64.64 0 0 0 .306-.079.66.66 0 0 0 .235-.217.69.69 0 0 0 .066-.629l-1.262-3.26v-3.24c0-1.611-.62-3.156-1.725-4.296A5.8 5.8 0 0 0 8 .9m1.31 13.5c0 .75-.582 1.35-1.31 1.35s-1.31-.6-1.31-1.35zM3.417 6.975A4.8 4.8 0 0 1 4.76 3.634 4.51 4.51 0 0 1 8 2.25c1.215 0 2.38.498 3.24 1.384a4.8 4.8 0 0 1 1.342 3.34v3.373q0 .13.047.25l.95 2.453H2.42l.95-2.453a.7.7 0 0 0 .048-.25z"
  })));
};
export default SvgBellIcon;